import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./promptTip.module.less";
import { connect } from "dva";
import { UserState } from "@/models/user";
import IconFont from "../icon";
import Marquee from "../chat/view/Main/Marquee";
import { usePrevious } from "@/utils/chat/index";
import { CloseMethod, KEY_PROMPT_VER } from "@/utils/tools";
import ImService from "@/server/ImService";

function mapStateToProps({ user }: { user: UserState }) {
  const { promptData } = user;
  return { promptData };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setPromptData(data: any) {
      dispatch({ type: "user/setPromptData", payload: data });
    }
  };
}

interface PromptTipProps {
  setPromptData: Function;
}

type IProps = Readonly<PromptTipProps & UserState>;

function PromptTip(props: IProps) {
  const { promptData, setPromptData } = props;
  const [isStart, setStartPlay] = useState(false);
  const warpRef = useRef<HTMLDivElement | null>(null);

  const timer = useRef<any>(0);

  const visible = useMemo(() => {
    return promptData?.isShow;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promptData.isShow]);

  const preVisible = usePrevious(visible);

  const setLocalTipVersion = useCallback((key: string) => {
    const date = new Date().getTime();
    ImService.getInstance()?.setAppVersion(
      JSON.stringify({
        date
      }),
      key
    );
  }, []);

  // 关闭
  const handleClose = useCallback(() => {
    setPromptData({
      isShow: false
    });
    if (CloseMethod.NO_CLOSE !== promptData.closeMethod) {
      // 设置本地
      setLocalTipVersion(KEY_PROMPT_VER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promptData.closeMethod, setPromptData]);

  useEffect(() => {
    if (visible && !preVisible) {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      if (warpRef.current) {
        const out = warpRef.current.clientWidth < warpRef.current.scrollWidth;
        setStartPlay(out);
      }
      if ([CloseMethod.AUTO_CLOSE, CloseMethod.COMM_CLOSE].includes(promptData.closeMethod)) {
        // 计时
        timer.current = setTimeout(() => {
          handleClose();
        }, promptData.autoCloseDuration * 1000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preVisible, visible, promptData]);

  const wrapStyle = useMemo(() => {
    return promptData?.backgroundColorCode
      ? {
          background: promptData?.backgroundColorCode
        }
      : {};
  }, [promptData.backgroundColorCode]);

  const contentStyle = useMemo(() => {
    return promptData?.textColorCode
      ? {
          color: promptData?.textColorCode
        }
      : {};
  }, [promptData.textColorCode]);

  const contentComp = useMemo(() => {
    return (
      <span className={`${styles["text"]} ${styles["content"]}`} style={contentStyle} ref={warpRef}>
        {promptData?.content || ""}
      </span>
    );
  }, [promptData, contentStyle]);

  return visible ? (
    <div className={styles["prompt-tip-wrap"]} style={wrapStyle}>
      <p className={styles["prompt-tip-content"]}>
        {!isStart ? (
          contentComp
        ) : (
          <Marquee pauseOnHover delay="1s">
            {contentComp}
          </Marquee>
        )}
        {[CloseMethod.COMM_CLOSE, CloseMethod.MANUAL_CLOSE].includes(promptData?.closeMethod) && (
          <IconFont
            type="iconjs_ic_closed"
            className={`${styles["text"]} ${styles["btn"]}`}
            onClick={handleClose}
          />
        )}
      </p>
    </div>
  ) : null;
}

export default connect(mapStateToProps, mapDispatchToProps)(PromptTip);
